/**
 * Device-local flag: this browser has successfully signed in or registered.
 * Used to prefer login over signup on public marketing CTAs.
 */

export const RETURNING_USER_STORAGE_KEY = 'jobmockai_returning_user';

export const markReturningUser = () => {
  try {
    localStorage.setItem(RETURNING_USER_STORAGE_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
};

export const hasReturningUser = () => {
  try {
    return localStorage.getItem(RETURNING_USER_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

/**
 * Soft-route public signup CTAs to login for returning visitors.
 * Referral (`ref=`) and explicit register intent stay on signup.
 */
export const resolvePublicAuthPath = (to) => {
  if (!to || typeof to !== 'string') return to;
  if (!hasReturningUser()) return to;

  const qIndex = to.indexOf('?');
  const pathname = qIndex === -1 ? to : to.slice(0, qIndex);
  const search = qIndex === -1 ? '' : to.slice(qIndex + 1);
  if (new URLSearchParams(search).has('ref')) return to;

  if (pathname === '/signup' || pathname === '/register') {
    return search ? `/login?${search}` : '/login';
  }

  return to;
};
